import styled from "styled-components";
import Variables from "../../assets/styleVariables";

export const Box = styled.div`
  position: relative;
  width: 100%;
  input {
    border: none;
    border-bottom: solid 1px;
    border-color: ${props => {
      switch (props.status) {
        case "warning":
          return Variables.colors.yellow_500;
        case "error":
          return Variables.colors.red_600;
        case "success":
          return Variables.colors.green;
        default:
          return Variables.colors.complementary_500;
      }
    }};
    width: 100%;
    padding: 12px 0;
    font-size: ${Variables.font_sizes.x2_medium};
    &:focus {
      box-shadow: none;
      outline: none;
      border-color: ${props => {
        switch (props.status) {
          case "warning":
            return Variables.colors.yellow_500;
          case "error":
            return Variables.colors.red_600;
          case "success":
            return Variables.colors.green;
          default:
            return Variables.colors.primary_vivid;
        }
      }};
    }
  }
  i {
    position: absolute;
    left: 0;
    top: 12px;
    font-size: 20px;
    margin-left: 20px;
    color: ${props => {
      switch (props.status) {
        case "warning":
          return Variables.colors.yellow_500;
        case "error":
          return Variables.colors.red_600;
        case "success":
          return Variables.colors.green;
        default:
          if (props.iconStatus === "focus") {
            return Variables.colors.primary_vivid;
          } else {
            return Variables.colors.complementary_500;
          }
      }
    }};
  }
  .notice {
    margin-bottom: 8px;
    display: block;
    padding: 4px 0;
    font-size: ${Variables.font_sizes.x_small};
    color: ${props => {
      switch (props.status) {
        case "warning":
          return Variables.colors.yellow_500;
        case "error":
          return Variables.colors.red_600;
        case "success":
          return Variables.colors.green;
        default:
          return Variables.colors.complementary_500;
      }
    }};
  }
  label {
    position: absolute;
    top: 12px;
    right: 0;
    font-size: ${Variables.font_sizes.x2_medium};
    color: ${Variables.colors.complementary_500};
    transition: 0.1s;
    ${props => {
      if (props.labelStatus === "top") {
        return `
            top: 0;
            font-size: ${Variables.font_sizes.small};
            `;
      }
    }}
  }
`;
